import {Component, Input, OnInit} from '@angular/core';
import {NavController} from "@ionic/angular";
import {OrderService} from "../../../../services/OrderService";
import {BusinessService} from "../../../../services/BusinessService";
import {Events} from "../../../../../framework/providers/events";

@Component({
  selector: 'cart-fab',
  templateUrl: './cart-fab.component.html',
  styleUrls: ['./cart-fab.component.scss'],
})
export class CartFabComponent implements OnInit {

  @Input()
  public options:object = {};

  @Input()
  public upperNeeded:boolean = false;

  public cartData:object;

  public upper:boolean;

  constructor(public navCtrl:NavController, public orderService:OrderService, public events:Events, public businessService:BusinessService) {
    this.cartData = orderService.getCartData();
  }

  ngOnInit() {
    this.upper = this.upperNeeded && this.businessService.getBusiness().data.GlobalSettingsData.tickets;
  }

  goTo(page, params = {})
  {
    this.navCtrl.navigateForward(page, params);
  }

}
